import { render, staticRenderFns } from "./responsibilitySwiper.vue?vue&type=template&id=2077c9e1&scoped=true&"
import script from "./responsibilitySwiper.vue?vue&type=script&lang=js&"
export * from "./responsibilitySwiper.vue?vue&type=script&lang=js&"
import style0 from "./responsibilitySwiper.vue?vue&type=style&index=0&id=2077c9e1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2077c9e1",
  null
  
)

export default component.exports